/*
 * @Author: lishuai lish@zhiding.com.cn
 * @Date: 2023-01-10 17:53:03
 * @LastEditors: lishuai lish@zhiding.com.cn
 * @LastEditTime: 2024-11-06 11:46:36
 * @FilePath: \sst-sjt-online-fe\src\router\index.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

/**
 * @description: 若路由跳转地址相同，且没有错误捕捉，3.x 及以上的版本的 router 回调会通过 promise api 的形式进行返回，添加一个错误的捕获，方式控制台报错
 * @return {*}
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 注：因为管理端和作答端都在一个项目中
// 会有要区分两种场景的需求，当前区分规则是，路由path中，包含，admin,manage的字样，认为是管理端路由
// 其它认为是考生端路由
// 新增，修改路由时候，需要要注意
const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/user/login' },
    { path: '/main-page', redirect: '/user/login' },
    { path: '/user-info', component: () => import('@/views/userInfo/userInfo.vue'), meta: { title: '个人中心' } },

    // 登录部分
    { path: '/user/login/code', name: 'userLoginSecretMode', component: () => import('@/views/login/userLoginSecretMode.vue'), meta: { title: '登录' } },
    { path: '/user/login', name: 'userLogin', component: () => import('@/views/login/userLogin.vue'), meta: { title: '登录' } },
    // 上次登陆是提前录入模式，当鉴权时间过去之后，要给用户提示，通过单击作答链接进入
    { path: '/last/login/tips', name: 'lastLoginTips', component: () => import('@/views/login/lastLoginTips.vue'), meta: { title: '' } },

    // 管理员登录
    { path: '/admin/login', name: 'adminLogin', component: () => import('@/views/login/adminLogin.vue'), meta: { title: '后台管理系统' } },
    { path: '/auth/admin/login', name: 'authAdminLogin', component: () => import('@/views/login/authAdminLogin.vue'), meta: { title: '后台管理系统' } },

    // 一体化项目
    { path: '/combine/list', name: 'combineList', component: () => import('@/views/combine/combineList.vue'), meta: { title: '情景判断测验及情景模拟演练系统' } },

    // SJT
    { path: '/sjt/sjtExamDesc', name: 'sjtExamDesc', component: () => import('@/views/sjt/examDesc.vue'), meta: { title: '' } },
    { path: '/sjt/exam', name: 'sjtExam', component: () => import('@/views/sjt/exam.vue'), meta: { title: '' } },
    { path: '/sjt/result', name: 'sjtResult', component: () => import('@/views/sjt/examResult.vue'), meta: { title: '' } },

    // SST 
    { path: '/sst/sstList', name: 'sstList', component: () => import('@/views/sst/sstList.vue'), meta: { title: '' } },
    { path: '/sst/sstIntro', name: 'sstIntro', component: () => import('@/views/sst/sstIntro.vue'), meta: { title: '' } },
    { path: '/sst/sstExam', name: 'sstExam', component: () => import('@/views/sst/sstExam.vue'), meta: { title: '' } },
    { path: '/sst/sstResult', name: 'sstResult', component: () => import('@/views/sst/sstResult.vue'), meta: { title: '' } },

    // manage 后台管理
    { path: '/manage/projectList', name: 'manageProjectList', component: () => import('@/views/manage/manageProjectList/manageProjectList.vue'), meta: { title: '项目列表' } },
    { path: '/manage/createProject', name: 'manageCreateProject', component: () => import('@/views/manage/manageCreateProject.vue'), meta: { title: '新建项目' } },
    { path: '/manage/updateProject', name: 'updateProject', component: () => import('@/views/manage/updateProject.vue'), meta: { title: '修改项目' } },

    
    // 后台人员部分
    { path: '/manage/personList', name: 'personList', component: () => import('@/views/manage/person/personList.vue'), meta: { title: '人员列表' } },
    { path: '/manage/addPerson', name: 'addPerson', component: () => import('@/views/manage/person/addPerson.vue'), meta: { title: '添加人员' } },
    { path: '/manage/editPerson', name: 'editPerson', component: () => import('@/views/manage/person/editPerson.vue'), meta: { title: '编辑人员' } },
    { path: '/manage/patchAddPerson', name: 'patchAddPerson', component: () => import('@/views/manage/person/patchAddPerson.vue'), meta: { title: '添加人员' } },
    { path: '/manage/patchUploadPerson', name: 'patchUploadPerson', component: () => import('@/views/manage/person/patchUploadPerson.vue'), meta: { title: '添加人员' } },

    // 操作说明
    { path: '/user/sstUserIntro', name: 'sstUserIntro', component: () => import('@/views/userInfo/sstUserIntro.vue'), meta: { title: '操作说明' } },
    { path: '/user/sjtUserIntro', name: 'sjtUserIntro', component: () => import('@/views/userInfo/sjtUserIntro.vue'), meta: { title: '操作说明' } },

    // 错误处理，项目已被删除的路由
    { path: '/project/notFound', name: 'projectNotFound', component: () => import('@/views/manage/projectNotFound.vue'), meta: { title: '项目不存在' } },

    // 下载一个文件
    { path: '/download/resultDownload', name: 'resultDownload', component: () => import('@/views/download/resultDownload.vue'), meta: { title: '报告下载' } },
  ],
})


router.beforeEach((to, from, next) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  next()
})

export default router
